import React from 'react';
import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';
import { frFR } from '@mui/x-data-grid/locales';
import styles from './DataGrid.module.scss';

// Default DataGrid styles
const DEFAULT_GRID_STYLES = {
  '& .MuiDataGrid-root': {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '14px',
    fontWeight: 500,
  },
  '& .MuiDataGrid-cell': {
    borderRight: '1px solid #e0e0e0',
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'unset',
    lineHeight: 1.3,
    alignItems: 'center',
    lineBreak: 'auto',
    minHeight: '45px !important',
  },
  '& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
    margin: '0px',
  },
  '& .MuiDataGrid-columnHeader': {
    borderRight: '1px solid #e0e0e0',
    backgroundColor: '#ebebeb',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    whiteSpace: 'normal',
    lineHeight: 1.3,
  },
  '& .MuiDataGrid-row:nth-of-type(even)': {
    backgroundColor: '#F2F2F2',
  },
  '& .MuiDataGrid-row.Mui-selected': {
    backgroundColor: '#eeb214 !important',
    color: 'black',
    '&:hover': {
      backgroundColor: '#d9a012 !important',
    },
  },
  height: '100%',
};

const DataGrid = ({
  rows,
  columns,
  getRowId,
  checkboxSelection = false,
  onRowSelectionModelChange,
  onRowClick = () => {},
  rowSelectionModel = [],
  pageSizeOptions = [25, 50, 100],
  initialPageSize = 25,
  autoRowHeight = true,
  customStyles = {},
  className = '',
  ...otherProps
}) => {
  const gridStyles = { ...DEFAULT_GRID_STYLES, ...customStyles };

  return (
    <div className={`${styles.container} ${className}`}>
      <MuiDataGrid
        rows={rows}
        columns={columns}
        getRowId={getRowId}
        checkboxSelection={checkboxSelection}
        onRowSelectionModelChange={onRowSelectionModelChange}
        rowSelectionModel={rowSelectionModel}
        pageSizeOptions={pageSizeOptions}
        onRowClick={onRowClick}
        initialState={{
          pagination: {
            paginationModel: { pageSize: initialPageSize, page: 0 },
          },
        }}
        getRowHeight={autoRowHeight ? () => 'auto' : undefined}
        sx={gridStyles}
        localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
        {...otherProps}
      />
    </div>
  );
};

export default DataGrid;
